import { createSelector } from '@reduxjs/toolkit';
import { ECustomerSource } from 'core/model/enums/customer.enum';
import { ICreditLimit } from 'core/model/interfaces/credits.interface';
import { authGetCustomerSource } from 'core/store/auth/selectors';
import { checkoutDetailSelector } from './core.selectors';

export const creditLimitsSelector = createSelector(
  checkoutDetailSelector,
  authGetCustomerSource,
  (checkoutDetail, customerSource): Array<ICreditLimit> => {
    if (customerSource === ECustomerSource.DEX || customerSource === ECustomerSource.APUDEX) {
      const generalMethodsPayment = checkoutDetail.generalCart.groupingRule.paymentMethods || [];
      return generalMethodsPayment.flatMap(method => (method.creditLine ? [method.creditLine] : []));
    }

    if (customerSource === ECustomerSource.HYBRID) {
      const alicorpMethodsPayment = checkoutDetail.alicorpCart.groupingRule.paymentMethods || [];
      const alliedMethodsPayment = checkoutDetail.alliedCart.groupingRule.paymentMethods || [];

      const alicorpCreditLimits = alicorpMethodsPayment.flatMap(method =>
        method.creditLine ? [method.creditLine] : [],
      );
      const alliedCreditLimits = alliedMethodsPayment.flatMap(method => (method.creditLine ? [method.creditLine] : []));

      return [...alicorpCreditLimits, ...alliedCreditLimits];
    }

    return [];
  },
);

export const creditLimitsBySourceSelector = createSelector(creditLimitsSelector, creditLimits =>
  creditLimits.reduce<Record<number, ICreditLimit>>((acc, current) => {
    acc[current.sourceId] = current;
    return acc;
  }, {}),
);

export const canBuySelector = createSelector(checkoutDetailSelector, detail => !detail.isPurchaseBlocked);

export const hasCreditsSelector = createSelector(
  creditLimitsBySourceSelector,
  creditLimit => Boolean(creditLimit[ECustomerSource.DEX]) || Boolean(creditLimit[ECustomerSource.APUDEX]),
);

export const hasNoCreditsForNonHybridSelector = createSelector(
  authGetCustomerSource,
  hasCreditsSelector,
  (source, hasCredits) => {
    const isApplicable = source === ECustomerSource.DEX || source === ECustomerSource.APUDEX;

    return isApplicable && !hasCredits;
  },
);
